// @flow

import React from 'react'
import Pagination from 'react-js-pagination'

type Props = {
  activePage: number,
  pageSize: number,
  totalItems: number,
  onChange: (number) => void,
}

export const RawPagination = (props: Props) =>
  <div className="row">
    <div className="col-xs-12">
      <div className="text-center">
        <Pagination
          activePage={props.activePage}
          itemsCountPerPage={props.pageSize}
          totalItemsCount={props.totalItems}
          onChange={props.onChange}
          prevPageText={'‹'}
          nextPageText={'›'}
        />
      </div>
    </div>
  </div>

export default RawPagination



// WEBPACK FOOTER //
// ./src/controls/pagination.js